<template>
<main class="content-body">
  <header class="page-header">
    <h2>Zone A</h2>
  </header>
  <div class="row">
    <div class="col-md-12 col-lg-12 col-xl-12">
      <div class="row panels-in-columns">
        <section class="panel">
          <header class="panel-heading">
            <h2 class="panel-title">Mes fournisseurs</h2>
          </header>
          <div class="panel-body">
            <MyServiceProviders :serviceproviders="serviceproviders"></MyServiceProviders>
            <router-link :to="{name: 'liste_fournisseurs'}">Voir tous les fournisseurs</router-link>
          </div>
        </section>
        <section class="panel">
          <header class="panel-heading">
            <h2 class="panel-title">Mes billets ouverts</h2>
          </header>
          <div class="panel-body">
            <MyLifecycleTickets :tickets="lifecycle_tickets"></MyLifecycleTickets>
            <router-link :to="{name: 'liste_billets', query: {ticket_resolution: 'open', responsable: current_user_id }}">Voir tous les bilets ouverts</router-link>
          </div>
        </section>
        <section class="panel">
          <header class="panel-heading">
            <h2 class="panel-title">Mes billets avec activité récente</h2>
          </header>
          <div class="panel-body">
            <MyTickets :tickets="tickets"></MyTickets>
            <router-link :to="{name: 'liste_billets', query: {responsable: current_user_id }}">Voir tous les bilets</router-link>
          </div>
        </section>
      </div>
    </div>
  </div>  
</main>
</template>

<style scoped>
  .panels-in-columns {
    columns: 3 450px;
    column-gap: 2rem;
  }
  .panel {
    display: inline-block;
    width: 100%;
  }
</style>

<script>
import MyServiceProviders from '@/components/MyServiceProviders.vue';
import MyTickets from '@/components/MyTickets.vue';
import MyLifecycleTickets from '@/components/MyLifecycleTickets.vue';

import axios from 'axios';

export default {
  name: 'OnTdb',
  data: function() {return {

    serviceproviders: [],
    tickets: [],
    lifecycle_tickets: [],
    current_user_id: '',
  }},

  components: {
    MyServiceProviders,
    MyTickets,
    MyLifecycleTickets
  },
  methods: {

    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/Tdb.php',
          { })
        .then(response => {
          this.serviceproviders = response.data.serviceproviders
          this.tickets = response.data.tickets
          this.lifecycle_tickets = response.data.lifecycle_tickets
          this.current_user_id = response.data.current_user_id
        })
    }
  },
  mounted () {
    this.refresh();
    /*this.polling = setInterval(function () {
      this.intervalExpiry();
    }.bind(this), 1000);*/
  },
  beforeDestroy () {
    clearInterval(this.polling)
  }
}
</script>
